import React from 'react';
import { useQuiz } from '../contexts/QuizContext';
import './QuizQuestion.css';

const QuizQuestion = ({ question, options, questionId, allowMultiple = false }) => {
  const { answers, handleAnswer } = useQuiz();
  
  const selectedAnswers = answers[questionId] || (allowMultiple ? [] : '');
  
  const handleOptionSelect = (option) => {
    if (allowMultiple) {
      const newSelection = selectedAnswers.includes(option)
        ? selectedAnswers.filter(item => item !== option)
        : [...selectedAnswers, option];
      
      handleAnswer(questionId, newSelection);
    } else {
      handleAnswer(questionId, option);
    }
  };
  
  // Função para obter a imagem correspondente à opção de barriga (somente para pergunta1)
  const getBarrigaImage = (option) => {
    if (questionId === 'pergunta1') {
      switch (option) {
        case 'Pequena pochete abaixo do umbigo':
          return '/images/barrigas/pochete.png';
        case 'Barriga arredondada e rígida':
          return '/images/barrigas/metabolica.png';
        case 'Barriga flácida, tipo avental':
          return '/images/barrigas/avental.png';
        default:
          return null;
      }
    }
    return null;
  };
  
  // Função para obter descrição da barriga (somente para pergunta1)
  const getBarrigaDescription = (option) => {
    if (questionId === 'pergunta1') {
      switch (option) {
        case 'Pequena pochete abaixo do umbigo':
          return 'Caracterizada por uma gordura localizada logo abaixo do umbigo, formando uma "pochete"';
        case 'Barriga arredondada e rígida':
          return 'Barriga protuberante e firme ao toque, muitas vezes relacionada ao estresse e hormônios';
        case 'Barriga flácida, tipo avental':
          return 'Excesso de pele e gordura que "cai" sobre o abdômen inferior, semelhante a um avental';
        default:
          return '';
      }
    }
    return '';
  };
  
  return (
    <div className="quiz-question">
      <h3 className="question-title">{question}</h3>
      <div className="options-container">
        {options.map((option, index) => {
          const barrigaImage = getBarrigaImage(option);
          const barrigaDescription = getBarrigaDescription(option);
          
          return (
            <div 
              key={index} 
              className={`option ${
                allowMultiple 
                  ? selectedAnswers.includes(option) ? 'selected' : '' 
                  : selectedAnswers === option ? 'selected' : ''
              } ${barrigaImage ? 'with-image' : ''}`}
              onClick={() => handleOptionSelect(option)}
            >
              <div className="option-marker">
                {allowMultiple ? (
                  <div className="checkbox">
                    {selectedAnswers.includes(option) && <div className="checkbox-inner" />}
                  </div>
                ) : (
                  <div className="radio">
                    {selectedAnswers === option && <div className="radio-inner" />}
                  </div>
                )}
              </div>
              <div className="option-content">
                <div className="option-text-container">
                  <div className="option-text">{option}</div>
                  {barrigaDescription && <div className="option-description">{barrigaDescription}</div>}
                </div>
                {barrigaImage && (
                  <div className="option-image-container">
                    <img 
                      src={barrigaImage} 
                      alt={`Imagem ${option}`} 
                      className="barriga-image" 
                      loading="lazy"
                    />
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuizQuestion; 